<template>
  <router-link class="series-category-btn" :to="link">
    <img :src="bg" :alt="category.label" />
    <div class="is-overlay">
      <h3>{{ category.label }}</h3>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    category: Object,
  },
  computed: {
    bg() {
      const initData = this.$store.state.initialData;
      return initData.basepath + this.category.image;
    },
    link() {
      return `seriescategory/${this.category.MIGX_id}`;
    },
  },
};
</script>

<style lang="scss">
.series-category-btn {
  max-width: 928px;
  min-width: 280px;
  max-height: 100px;
  overflow: hidden;
  margin: 1rem auto;
  display: block;
  position: relative;
  transition: all 0.2s ease;
  .is-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  h3 {
    color: #000000;
    font-weight: bold;
    font-size: 1.5rem;
  }
  &:hover {
    transform: scale(1.1);
  }
}

@media screen and (min-width: 768px) {
  .series-category-btn {
    margin: 1rem;
  }
}
</style>